/**
 * textMessageDraftReducer.js
 * Talkroute
 *
 * Created by Vel Genov on 3/14/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

import { REHYDRATE } from "redux-persist";

import { FILES_UPDATED, FILES_REMOVED } from "@actions/textMessageDraftActions";

import {
  CLOSE_CONVERSATION,
  SEND_MESSAGE_SUCCESS,
  SELECT_CONVERSATION,
  FETCH_CONVERSATIONS_SUCCESS,
  SEND_MESSAGE_STARTED,
  SEND_MESSAGE_FAILURE,
} from "@actions/conversationActions";
import dataStateEnum from "@constants/dataStateConstants";
import FilePathHelper from "@helpers/filePathHelper";

export interface ITextMessageDraftReducer {
  files: any;
  sendingState: dataStateEnum;
}

const initialState = {
  files: null,
  sendingState: dataStateEnum.READY,
};

/**
 * Stores draft messages
 *
 * @param {*} state
 * @param {*} action
 */
export default function textMessageDraft(state: ITextMessageDraftReducer = initialState, action): ITextMessageDraftReducer {
  const filePathHelper = new FilePathHelper();
  switch (action.type) {
    case REHYDRATE:
      // A redux-persist action. Called immediately after launch. It clears any existing draft state

      return {
        ...state,
      };

    case FILES_UPDATED: {
      // Draft message files have been updated

      const { files } = action.payload;

      return {
        ...state,
        files: [files],
      };
    }

    case FILES_REMOVED: {
      // Draft message files have been removed
      filePathHelper.clearTempFoler();

      return {
        ...state,
        files: null,
      };
    }

    case CLOSE_CONVERSATION: {
      // A conversation has been closed
      filePathHelper.clearTempFoler();

      return {
        ...state,
        files: null,
      };
    }

    case SEND_MESSAGE_STARTED: {
      // Sending of the current draft message has started
      return {
        ...state,
        sendingState: dataStateEnum.LOADING,
      };
    }

    case SEND_MESSAGE_SUCCESS: {
      // Sending of the current draft message was successfull
      filePathHelper.clearTempFoler();

      return {
        ...state,
        files: null,
        sendingState: dataStateEnum.READY,
      };
    }

    case SEND_MESSAGE_FAILURE: {
      // Sending of the current draft message has failed
      return {
        ...state,
        sendingState: dataStateEnum.READY,
      };
    }

    case SELECT_CONVERSATION: {
      // A conversation has been selected/changed
      filePathHelper.clearTempFoler();

      return {
        ...state,
        files: null,
      };
    }

    case FETCH_CONVERSATIONS_SUCCESS: {
      // Conversations have been fetched successfully
      const { clearDraft } = action.payload.conversations;

      if (clearDraft) {
        filePathHelper.clearTempFoler();

        return {
          ...state,
          files: null,
        };
      }

      return {
        ...state,
      };
    }

    default:
      return state;
  }
}
